/* Transfer (gang sheet) calculator */
IDP.transferInit = function (cfg) {
  const lengths = [];
  cfg.variants.forEach((v) => { if (!lengths.find((l) => l.name === v.option1)) lengths.push({ name: v.option1, price: v.price }); });
  const calc = {
    i: Math.min(1, lengths.length - 1), q: 1, peel: (cfg.peels && cfg.peels[0]) || 'Hot', rush: false, file: null,
    variant() { return cfg.variants.find((v) => v.option1 === lengths[calc.i].name && (!v.option2 || v.option2 === calc.peel)); },
    init() {
      $('idp-sizes').innerHTML = lengths.map((l, i) => `<button type="button" class="idp-sizecard ${i === calc.i ? 'on' : ''}" onclick="IDP.calc.size(${i})"><b>${cfg.width} × ${l.name}</b><span>${IDP.money(l.price)}</span></button>`).join('');
      if ($('idp-peels')) $('idp-peels').innerHTML = (cfg.peels || []).map((p) => `<button type="button" class="chip ${p === calc.peel ? 'on' : ''}" onclick="IDP.calc.setPeel('${p}')">${p} peel</button>`).join('');
      calc.render();
    },
    size(i) { calc.i = i; calc.init(); },
    qty(d) { calc.q = Math.max(1, calc.q + d); $('idp-qty').textContent = calc.q; calc.render(); },
    setPeel(p) { calc.peel = p; calc.init(); },
    toggleRush() { calc.rush = !calc.rush; $('idp-rush').classList.toggle('on', calc.rush); calc.render(); },
    onFile(inp) { calc.file = inp.files[0] || null; $('idp-fileName').textContent = calc.file ? calc.file.name + ' ✓' : 'Drop your PNG here or click to browse'; },
    render() {
      const v = calc.variant(); const unit = v ? v.price : lengths[calc.i].price;
      const sub = unit * calc.q;
      let disc = 0; (cfg.discounts || []).forEach((d) => { if (calc.q >= d[0]) disc = Math.max(disc, d[1]); });
      const d = Math.round(sub * disc / 100); const rush = calc.rush ? cfg.rushPrice : 0; const tot = sub - d + rush;
      $('idp-tot').textContent = IDP.money(tot); $('idp-totSub').textContent = 'for ' + calc.q + ' sheet' + (calc.q > 1 ? 's' : '');
      $('idp-lines').innerHTML = `<div class="idp-row"><span>${calc.q} × ${cfg.width} × ${lengths[calc.i].name} gang sheet</span><b>${IDP.money(sub)}</b></div>` +
        (disc ? `<div class="idp-row"><span>Multi-sheet discount ${disc}% (applied at checkout)</span><b>−${IDP.money(d)}</b></div>` : '') +
        (rush ? `<div class="idp-row"><span>${cfg.rushLabel}</span><b>${IDP.money(rush)}</b></div>` : '') +
        `<div class="idp-row"><span>Shipping</span><b>${tot >= cfg.freeShip ? 'Free over ' + IDP.money(cfg.freeShip) : cfg.shipText}</b></div>`;
      const btn = $('idp-add'); if (btn) btn.disabled = !v || v.available === false;
      if ($('idp-soldout')) $('idp-soldout').hidden = !(v && v.available === false);
    },
    async add() {
      const v = calc.variant(); if (!v) return;
      const btn = $('idp-add'); IDP.busy(btn, true, 'Adding…');
      try {
        const fd = new FormData();
        fd.append('id', v.id); fd.append('quantity', calc.q);
        if (calc.file) fd.append('properties[Artwork]', calc.file); else fd.append('properties[Artwork]', 'Will email to ' + cfg.email);
        fd.append('properties[Peel]', calc.peel);
        const notes = $('idp-notes') && $('idp-notes').value.trim(); if (notes) fd.append('properties[Notes]', notes);
        await IDP.cartAdd(fd, { render: !calc.rush });
        if (calc.rush && cfg.rushVariant) { const fr = new FormData(); fr.append('id', cfg.rushVariant); fr.append('quantity', 1); await IDP.cartAdd(fr); }
        toast('Added to cart.');
      } catch (e) { toast(e.message); }
      IDP.busy(btn, false, 'Add to cart');
    },
  };
  IDP.calc = calc; calc.init();
  if ($('idp-cd')) {
    const tick = () => {
      const n = new Date(); const now = new Date(n.toLocaleString('en-US', { timeZone: cfg.tz || 'America/Chicago' }));
      const c = new Date(now); c.setHours(cfg.cutoffHour, 0, 0, 0); if (c < now) c.setDate(c.getDate() + 1);
      const m = Math.floor((c - now) / 60000); $('idp-cd').textContent = Math.floor(m / 60) + 'h ' + (m % 60) + 'm';
    };
    tick(); setInterval(tick, 30000);
  }
};
